import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { supabase } from '../supabaseClient';

const WithdrawPage = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    fetchWithdrawals();
  }, [currentPage]);

  const fetchWithdrawals = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('withdrawal')
      .select('*');

    if (error) {
      console.error(error);
    } else {
      setWithdrawals(data);
    }
    setLoading(false);
  };

  const updateStatus = async (id, newStatus) => {
    const { error } = await supabase
      .from('withdrawal')
      .update({ status: newStatus })
      .eq('id', id);

    if (error) {
      console.error(error);
    } else {
      fetchWithdrawals();
      toast.success('Status successfully updated');
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filteredWithdrawals = withdrawals.filter(
    (item) =>
      item.businessName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.amountWithdrawn.toString().includes(searchQuery)
  );

  const pendingWithdrawals = filteredWithdrawals.filter(item => item.status === 'pending');
  const successfulWithdrawals = filteredWithdrawals.filter(item => item.status === 'successful');

  const displayedWithdrawals = currentPage === 1 ? pendingWithdrawals : successfulWithdrawals;

 return (
    <div className="container mb-0 pb-0">
      <h3 className="mb-4">Withdrawals</h3>
      <input
        type="text"
        placeholder="Search by Business Name or Amount Withdrawn"
        className="form-control"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <div className="d-flex justify-content-center mt-4">
        <button
          className={`btn ${currentPage === 1 ? 'btn-primary' : 'btn-secondary'} mx-1`}
          onClick={() => handlePageChange(1)}
        >
          Pending
        </button>
        <button
          className={`btn ${currentPage === 2 ? 'btn-primary' : 'btn-secondary'} mx-1`}
          onClick={() => handlePageChange(2)}
        >
          Successful
        </button>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="table-responsive" style={{width: '78vw', height: '52vh'}}>
          <table className="table table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Business Name</th>
                <th>Bank Details</th>
                <th>Status</th>
                <th>Current Balance</th>
                <th>Amount Withdrawn</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {displayedWithdrawals.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.businessName}</td>
                  <td>
                    <p>Bank Name: {item.bankDetails.bank_name}</p>
                    <p>Account Name: {item.bankDetails.account_name}</p>
                    <p>Account Number: {item.bankDetails.account_number}</p>
                  </td>
                  <td className={item.status === 'pending' ? 'text-danger' : 'text-success'}>
                    {item.status}
                  </td>
                  <td>{item.currentBalance}</td>
                  <td>{item.amountWithdrawn}</td>
                  <td>
                    {item.status === 'pending' && (
                      <button
                        className="btn text-primary"
                        onClick={() => updateStatus(item.id, 'Successful')}
                      >
                        Confirm Withdrawal
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default WithdrawPage;
